import React from 'react'
import {ACCESS_LABELS} from './constants'
import type {ShareAccess} from './types'

interface OwnedByProps {
  ownerName: string
  /** The viewer's access, shown after the owner when given (members see "Can view" / "Can edit"). */
  access?: ShareAccess
  className?: string
}

/**
 * "Owned by Ana García" for a folder someone else shared with you (P1-F5, D9). Members always see
 * whose storage a shared folder lives in; use it in the Shared root and the folder header.
 */
export const OwnedBy: React.FC<OwnedByProps> = ({ownerName, access, className}) => (
  <span className={`ob-sharing-owned-by text-muted ${className ?? ''}`.trim()}>
    Owned by <span className='fw-semibold'>{ownerName || 'another user'}</span>
    {access && access !== 'owner' && <> · {ACCESS_LABELS[access]}</>}
  </span>
)
